import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    ButtonsContainer,
    ButtonWrapper,
} from 'src/components/CustomersBar/CustomerTab/BankingTab/components/PaymentsAdditions.style';
import { Amount } from 'src_common/common/amount/Amount';
import { CurrencyType, moneySymbol } from 'src_common/common/amount/website-money/currency';

interface ButtonAmountPropsType {
    value: string;
    amount: string;
    currency: CurrencyType;
    onChange: (amount: Amount) => void;
}

const ButtonAmount = observer('ButtonAmount', (props: ButtonAmountPropsType) => {
    const { currency, amount } = props;

    const handleChange = (): void => {
        const { value, onChange, amount } = props;

        const currValue = new Amount(value === '' ? '0' : value);
        const valueFromBtn = new Amount(amount);
        onChange(currValue.add(valueFromBtn));
    };

    return (
        <ButtonWrapper onClick={handleChange}>
            +{moneySymbol(currency)}
            {amount}
        </ButtonWrapper>
    );
});

interface PropsType {
    value: string;
    currency: CurrencyType;
    options?: Array<string>;
    actionButtonLabel?: string;
    onChange: (amount: Amount) => void;
    handleActionOnInput: () => void;
}

export const PaymentAdditionsNew = observer('PaymentAdditionsNew', (props: PropsType) => {
    const defOptions = ['10', '20', '50', '100'];
    const { options = defOptions, currency, actionButtonLabel = 'Clear', value, onChange, handleActionOnInput } = props;

    return (
        <ButtonsContainer data-test='payment-additions-new'>
            {options.map((amount) => (
                <ButtonAmount
                    key={amount}
                    value={value}
                    onChange={onChange}
                    amount={amount}
                    currency={currency}
                />
            ))}
            <ButtonWrapper
                key='action-button'
                onClick={handleActionOnInput}
            >
                {actionButtonLabel}
            </ButtonWrapper>
        </ButtonsContainer>
    );
});
